import React, { useRef } from 'react';
import { useState, useEffect, usePrintContext, Hooks, Form, Field, Title, Code, Actions, Files, API, Utility, Button, Control } from 'helpers/PrintImports';
import { Document } from 'models/DocumentModel';

const DocumentPrint: React.FC = () => {
  const [formId, formName] = [Code.Form.Id.DOCUMENT, Code.Form.Name.DOCUMENT];
  const {keyId, loading, setLoading, showMenu, setShowMenu, message, setMessage, error, setError, menuPosition, setMenuPosition, contextMenuRef } = usePrintContext();
  const [fileUrl, setFileUrl] = useState<string | null>(null);

  const Privilege = Hooks.Privilege.List(formId);
  const printRef = useRef<HTMLDivElement>(null);
  Hooks.Privilege.HasPrint(Privilege);

  useEffect(() => {
    API.Data.GetByKeyId<Document>(formName, keyId, setLoading, setError)
      .then(async(data) => { if(data) {
        if (data.document_file_name) {
          const url = await Files.File.Fetch(data.document_file_name,"document");
          setFileUrl(url);
        }
    }})
    setLoading(false);
  }, []); 

  return (
    <Control.Print.Frame setMenuPosition={setMenuPosition} setShowMenu={setShowMenu}>
      {!loading && (<>
        {/* <div className="print-buttons">
          <button 
            id="btnPrint" 
            className="ibutton bprint" 
            accessKey="p"
            title="Print Preview (Alt+P)"
            onClick={() => {
              const iframe = document.querySelector('.preview-file') as HTMLIFrameElement;
              if (iframe?.contentWindow) {
                iframe.contentWindow.focus();
                iframe.contentWindow.print();
              } else if (fileUrl) {
                // Fallback: open in new tab and print
                const printWindow = window.open(fileUrl, '_blank');
                printWindow?.addEventListener('load', () => printWindow.print());
              }
            }}
          >
            Print
          </button>
          {fileUrl && (
            <button
              id="btnOpen"
              className="ibutton bopen"
              accessKey="o"
              title="Open in Browser (Alt+O)"
              onClick={() => window.open(fileUrl, '_blank')}
            >
              Open
            </button>
           )}

           {fileUrl && (
            <button
              id="btnDownload"
              className="ibutton bdownload"
              accessKey="d"
              title="Download (Alt+D)"
              onClick={() => {
                const a = document.createElement('a');
                a.href = fileUrl;
                a.download = `document_${new Date().toISOString().replace(/[-T:Z.]/g, '').slice(0, 14)}.pdf`;
                a.click();
              }}
            >
              Download
            </button>
           )}
        </div> */}
        <Button.PrintDocument keyId={keyId} fileUrl={fileUrl} formName={formName} Privilege={Privilege} fileName='order' printRef={printRef} setMessage={setMessage} setError={setError} />
        <Control.Print.Data ref={printRef}>
          <Field.Document fileUrl={fileUrl} />
        </Control.Print.Data>    
      </>)}
    {showMenu && (<div ref={contextMenuRef}><Control.PrintContextMenu keyId={keyId} showMenu={showMenu} formName={formName}  setShowMenu={setShowMenu} Privilege={Privilege} pos={menuPosition} /></div>)}
    <Actions.Print />
    </Control.Print.Frame>
  );
};

export default DocumentPrint;